import { STEP_PAGES } from "./ga-enums";
import { CCPAEligibility, CCPARiamSignIn, PageDetails } from "./ga-page-details";

export type PageMapping = {
  [key: string]: PageDetails;
};

export const GAPageMapping: PageMapping = {
  [STEP_PAGES.ELIGIBILITY]: CCPAEligibility,
  [STEP_PAGES.RIAMSIGNIN]: CCPARiamSignIn
};
